import React from "react";
import { Row, Col, Table, Form, } from "react-bootstrap";
import { ToWords } from "to-words";
import bill from "../../../../assets/images/logo6-small.png";
import fitplus from "../../../../assets/images/fitPlusLogo.png";
import GlobalCurrency from "../GlobalCurrency";
import { getLocalizedDate } from "../../../shared/helpers/localizationHelper";
import { GlobalAddress } from "../../../shared/helpers/globalAddress";
import { useSelector } from "react-redux";
import { placeOfSupplyList } from "../../../shared/config/placeOfSupply";


const DefaultInvoice = ({ item, componentRef }) => {


  const { tenants, user } = useSelector((state) => state?.auth);


  const words = new ToWords().convert(item?.grand_total);
  const billingAddress = item?.order_billing_addresses[0];
  const filterState = placeOfSupplyList.find((state)=> state.value == billingAddress?.state );
  console.log("filterState",billingAddress)
  return (
    <>
      <div ref={componentRef}
        className="px-3 py-2"
        style={{ backgroundColor: "white" }}
      >


        <div className=" px-5 py-3">
          <Row className="p-0" style={{ minHeight: '80px' }}>
            <Col lg={8} className="p-0  m-0">
              <p style={{ fontWeight: "bolder", fontSize: '12px' }}>
                TAX INVOICE
                <span
                  className="border border-secondary px-2 mx-2"
                  style={{ fontWeight: 500, fontSize: '12px' }}
                >
                  ORIGINAL FOR RECIPIENT
                </span>
              </p>
            </Col>
            <Col lg={4} className="d-flex justify-content-between p-0">
              <div >
                <div>
                  <Form.Label className="mb-0" style={{ fontWeight: '600', fontSize: '12px' }}>
                    Order - #
                  </Form.Label>
                </div>
                <div>
                  <Form.Label className="mb-0" style={{ fontWeight: '600', fontSize: '12px' }}>
                    Date
                  </Form.Label>
                </div>
              </div>
              <div >
                <div>:</div>
                <div>:</div>
              </div>
              <div >
                <div>
                  <Form.Label className="mb-0" style={{ fontSize: '12px' }}>
                    {item?.order_number}
                  </Form.Label>
                </div>
                <div>
                  <Form.Label className="mb-0" style={{ fontSize: '12px' }}>
                    {getLocalizedDate(item?.created_at)}
                  </Form.Label>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="" style={{ minHeight: '130px' }}>
            <Col lg={8} className="px-0">
              <Col lg={12}
                style={{
                }}
              >

                {tenants[0]?.flavor == "fitplusclub" ? <img
                  src={fitplus}
                  alt="Logo"
                  style={{
                    width: "auto",
                    height: "40px",
                    objectFit: "contain",
                  }}
                /> : <img
                  src={bill}
                  alt="Logo"
                  style={{
                    width: "auto",
                    height: "40px",
                    objectFit: "contain",
                  }}
                />}
              </Col>
              <Col lg={12}>
                <Form.Label className="mb-0" style={{ fontWeight: '400', fontSize: '12px' }}>
                  {GlobalAddress.address1}{GlobalAddress.address1 && ','}
                </Form.Label>
              </Col>
              <Col lg={12}>
                <Form.Label className="mb-0" style={{
                  fontSize: "12px",
                  fontWeight: 400,
                }}>
                  {GlobalAddress.city}{GlobalAddress.city && ','} &nbsp;
                  {GlobalAddress.state}&nbsp;{GlobalAddress.state && '-'}&nbsp;
                  {GlobalAddress.pincode}{GlobalAddress.pincode && '.'}
                </Form.Label>
              </Col>
              <Col lg={12}>
                <Form.Label style={{
                  fontSize: "12px",
                  fontWeight: 400,
                }}>
                  <span style={{ fontWeight: '600' }}>Phone : </span>   {GlobalAddress.phone}
                </Form.Label>
              </Col>

            </Col>
            {!billingAddress &&
              <Col lg={4} className="px-0">
                <Col lg={12} className="">
                  <Form.Label className="mb-0" style={{ fontWeight: '600', fontSize: '13px' }}>Bill to &nbsp;</Form.Label>
                </Col>
                <Form.Label className="mb-0" style={{ fontWeight: '500', fontSize: '12px', textTransform: 'capitalize' }}>
                  {user?.name}
                </Form.Label>
                <Col lg={12}>
                  <Form.Label style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    <span style={{ fontWeight: '600' }}>Phone : </span>   {user?.phone}
                  </Form.Label>
                </Col>
              </Col>
            }
            {billingAddress && <Col lg={4} className="px-0">
              <Col lg={12} className="">
                <Form.Label className="mb-0" style={{ fontWeight: '600', fontSize: '13px' }}>Bill to &nbsp;</Form.Label>
              </Col>
              <Form.Label className="mb-0" style={{ fontWeight: '500', fontSize: '12px', textTransform: 'capitalize' }}>
                {item?.order_billing_addresses[0]?.name}
              </Form.Label>
              {billingAddress?.address1 && (
                <Col lg={12}>
                  <Form.Label className="mb-0" style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    {item?.order_billing_addresses[0]?.address1}
                    {item?.order_billing_addresses[0]?.address1 && ','}&nbsp;
                    {item?.order_billing_addresses[0]?.address2}
                    {item?.order_billing_addresses[0]?.address2 && ','}
                  </Form.Label>
                </Col>
              )}

              {billingAddress?.city && (
                <Col lg={12}>
                  <Form.Label className="mb-0" style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    {item?.order_billing_addresses[0]?.city}
                    {item?.order_billing_addresses[0]?.city && ' , '}
                    {billingAddress?.state && ` ${filterState?.label}`}
                    {billingAddress?.state && billingAddress?.pincode && ' - '}
                    {billingAddress?.pincode && ` ${item?.order_billing_addresses[0]?.pincode}`}
                  </Form.Label>
                </Col>
              )}
              {billingAddress?.gstin && (
                <Col lg={12}>
                  <Form.Label className="mb-0" style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    <span style={{ fontWeight: '600' }}>GSTIN : </span>   {item?.order_billing_addresses[0]?.gstin}
                  </Form.Label>
                </Col>
              )}
              {billingAddress?.phone_number && (
                <Col lg={12}>
                  <Form.Label style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}>
                    <span style={{ fontWeight: '600' }}>Phone : </span>   {item?.order_billing_addresses[0]?.phone_number}
                  </Form.Label>
                </Col>
              )}
            </Col>}
          </Row>


          <Row className="mt-5">
            <Table className="table table-borderless" style={{ minHeight: '250px' }}>
              <thead>
                <tr

                >
                  <th
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      // borderBottom: "1px solid black",
                      //borderTop: "1px solid black",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    S.No
                  </th>
                  <th
                    style={{
                      fontSize: "12px",
                      fontWeight: 600,
                      // borderBottom: "1px solid black",
                      // borderTop: "1px solid black",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    Name
                  </th>

                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: 600,
                      // borderBottom: "1px solid black",
                      // borderTop: "1px solid black",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    QTY
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: 600,
                      // borderBottom: "1px solid black",
                      // borderTop: "1px solid black",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    Price
                  </th>
                  <th
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      fontWeight: 600,
                      // borderBottom: "1px solid black",
                      // borderTop: "1px solid black",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    Tax
                  </th>

                  <th
                    style={{
                      textAlign: "right",
                      fontSize: "12px",
                      fontWeight: 600,
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    Total
                  </th>
                </tr>
              </thead>
              <tbody >
                {item?.order_items?.filter(oi => (oi?.quantity ?? 0) > 0)?.map((oi, idx) => {
                  const isPlan = !!oi?.plan;
                  const name = isPlan ? oi?.plan?.label : oi?.addon?.label;
                  const unitPrice = isPlan ? oi?.plan?.price : oi?.addon?.price;
                  return (
                    <tr key={idx} className="py-0"
                      style={{ fontSize: "12px", fontWeight: 400, borderBottom: "1px solid #E2E2E2" }}>
                      <td className="py-0" style={{ fontSize: "12px", fontWeight: 400, borderBottom: "1px solid #E2E2E2" }}>{idx + 1}</td>
                      <td className="py-0" style={{ fontSize: "12px", fontWeight: 400, borderBottom: "1px solid #E2E2E2" }}>
                        {name} {isPlan ? '( Plan )' : '( Addon )'}
                      </td>
                      <td className="py-0" style={{ textAlign: "center", borderBottom: "1px solid #E2E2E2" }}>{oi?.quantity}</td>
                      <td className="py-0" style={{ textAlign: "center", borderBottom: "1px solid #E2E2E2" }}>
                        <GlobalCurrency value={unitPrice} />
                      </td>
                      <td className="py-0" style={{ textAlign: "center", borderBottom: "1px solid #E2E2E2" }}>
                        <GlobalCurrency value={oi?.tax_total} />
                      </td>
                      <td className="py-0" style={{ textAlign: "right", borderBottom: "1px solid #E2E2E2" }}>
                        <GlobalCurrency value={oi?.subtotal} />
                      </td>
                    </tr>
                  );
                })}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
              <tfoot>
                <tr
                  style={{
                    fontSize: "12px",
                    fontWeight: 400,
                  }}
                >
                  <td
                    style={{
                      borderBottom: "1px solid #E2E2E2",
                      borderTop: "1px solid #E2E2E2",
                    }}
                  >
                    SUB TOTAL
                  </td>
                  <td style={{

                    borderBottom: "1px solid #E2E2E2",
                    borderTop: "1px solid #E2E2E2",
                  }}></td>
                  <td
                    style={{
                      textAlign: "right",
                      borderBottom: "1px solid #E2E2E2",
                      borderTop: "1px solid #E2E2E2",
                    }}
                  ></td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #E2E2E2",
                      borderTop: "1px solid #E2E2E2",
                    }}
                  >
                    <GlobalCurrency value={item?.taxable_value} />
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #E2E2E2",
                      borderTop: "1px solid #E2E2E2",
                    }}
                  >
                    <GlobalCurrency value={item?.tax_total} />
                  </td>
                  <td
                    style={{
                      textAlign: "right",
                      borderBottom: "1px solid #E2E2E2",
                      borderTop: "1px solid #E2E2E2",
                    }}
                  >
                    <GlobalCurrency value={item?.grand_total} />
                  </td>
                </tr>
              </tfoot>
            </Table>
            <div className="d-flex justify-content-between  p-0" style={{ minHeight: '150px' }}>
              <div className="d-flex flex-column col-lg-6">
                <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>
                  Total Amount (In Words)
                </Form.Label>{" "}
                <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}>
                  {words ? `${words.toUpperCase()} ONLY` : "ZERO RUPEES"}
                </Form.Label>{" "}
              </div>
              <div className="col-lg-6 " >
                <div className="d-flex justify-content-between px-1">
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>Taxable Amount</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.taxable_value} /></Form.Label>
                </div>
                <div className="d-flex justify-content-between px-1">
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>CGST @ {item?.selected_plan?.tax_rate / 2}%</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.tax_total / 2} /></Form.Label>
                </div>
                <div className="d-flex justify-content-between px-1">
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>SGST @ {item?.selected_plan?.tax_rate / 2}%</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.tax_total / 2} /></Form.Label>
                </div>
                <div className="d-flex justify-content-between px-1 py-1" style={{ borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray' }}>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>TOTAL</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.grand_total} /></Form.Label>
                </div>
                <div className="d-flex justify-content-between px-1">
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>Received</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.paid_amount} /></Form.Label>
                </div>
                <div className="d-flex justify-content-between px-1">
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>Balance</Form.Label>
                  <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 400 }}><GlobalCurrency value={item?.grand_total} /></Form.Label>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between mt-2 p-0">
              <div className="d-flex flex-column col-lg-6">
                <Form.Label className="mb-0" style={{ fontSize: "12px", fontWeight: 600 }}>
                  Terms And Conditions
                </Form.Label>
                <Form.Label style={{ fontSize: "12px", fontWeight: 400 }}>
                  1. Automatic Renewal: Your subscription renews automatically each billing cycle, and your payment method will be charged unless you cancel beforehand.
                </Form.Label>
                <Form.Label style={{ fontSize: "12px", fontWeight: 400 }}>
                  2. Cancellation: Cancel anytime through your account. No refunds for partial billing cycles; service continues until the end of the current period.
                </Form.Label>
              </div>
              <div className="d-flex flex-column col-lg-6 px-1">
                <Form.Label className="mb-1" style={{ fontSize: "12px", fontWeight: 600 }}>
                  Authorized Signatory For Bill plus
                </Form.Label>
                <div className="border"
                  style={{ height: "60px" }}>

                </div>
              </div>

            </div >


          </Row>
        </div>
      </div>
    </>
  );
};

export default DefaultInvoice;
